import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FingerprintConfigurationNonPayrollEmployeeActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Hr/EmployeeNonPayroll/EmployeeNonPayrollBrowser")
	}

	render() {
		return (
			<Activity 
				name="FingerprintConfigurationNonPayrollEmployee"
				RenderedComponent={this.RenderedComponent}
				context="FingerprintConfigurationNonPayrollEmployee"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FingerprintConfigurationNonPayrollEmployeeActivity)
